import { DateTime } from "luxon";

import { getFirstStartedAtTs } from "@intelligems/ig-analytics/experience-status";
import { CHECKOUT_BLOCK_VIEWED_AVAILABLE_FROM } from "@src/features/analytics/constants";
import { useSelector } from "@src/store";
import { selectedExperience } from "@src/store/slices/experiences";

export const useGetCheckoutBlockViewedAvailableDateLabel = () =>
  // Format in the constant's own (UTC) zone so the calendar date reads as
  // authored — org timezones west of UTC would otherwise roll it back a day.
  DateTime.fromISO(CHECKOUT_BLOCK_VIEWED_AVAILABLE_FROM, {
    setZone: true,
  }).toFormat("MMMM d, yyyy");

// A warning is needed when the user is viewing the checkout-block stage over a
// window that reaches before the collection date — so part (straddle) or all
// (fully pre-collection) of the series is missing. Window start defaults to the
// experience's own start (full lifetime) when no range is selected. This is
// independent of the default-stage fallback, which keys off the test's end.
export const useIsCheckoutBlockViewedDataIncomplete = () => {
  const startTime = useSelector((state) => state.dashboardFilters.startTime);
  const reachedCheckoutStage = useSelector(
    (state) => state.dashboardFilters.reachedCheckoutStage
  );
  const experience = useSelector(selectedExperience);
  const experienceStartTs =
    getFirstStartedAtTs(experience?.experienceActions) ?? 0;

  const windowStartTs =
    startTime != null ? Number(startTime) : experienceStartTs;

  return (
    reachedCheckoutStage === "checkout_block_viewed" &&
    windowStartTs <
      DateTime.fromISO(CHECKOUT_BLOCK_VIEWED_AVAILABLE_FROM).toMillis()
  );
};
